import { Store } from 'react-notifications-component'

const optiopns = {
    insert: 'top',
    container: 'top-right',
    animationIn: ['animate__animated', 'animate__fadeIn'],
    animationOut: ['animate__animated', 'animate__fadeOut'],
    dismiss: {
        duration: 3000,
        // onScreen: true,
    },
}

export const useNotification = () => {
    const successToast = msg => {
        Store.addNotification({
            message: msg,
            type: 'success',
            ...optiopns,
        })
    }
    const errorToast = msg => {
        Store.addNotification({
            message: msg,
            // react-notifications-component uses "danger" for red error styling
            type: 'danger',
            ...optiopns,
        })
    }
    const warningToast = msg => {
        Store.addNotification({
            message: msg,
            type: 'warning',
            ...optiopns,
        })
    }
    return { successToast, errorToast, warningToast }
}
